import { MediaDialogComponent } from "src/app/new-media/new-media-manager/media-dialog/media-dialog.component";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  ViewContainerRef,
  TemplateRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ViewFileComponent } from "../../media-manager/view-file/view-file.component";
import { ModuleService } from "src/app/services/module.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "../../../services/auth.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from "@angular/material/dialog";
declare const $: any;
@Component({
  selector: "app-add-edit-blog",
  templateUrl: "./add-edit-blog.component.html",
  styleUrls: ["./add-edit-blog.component.css"],
})
export class AddEditBlogComponent implements OnInit {
  @ViewChild("content", { read: ViewContainerRef, static: true })
  content: ViewContainerRef;
  @ViewChild("uploadThumbnail", { static: true })
  uploadThumbnailRef: ElementRef;
  @ViewChild("postName", { static: true })
  @Output()
  result = new EventEmitter<any>();

  searchText = "";
  postThumbnail: File[] = [];
  post: any = { postThumbnails: [] };
  files: File[] = [];
  templateId: number;
  allTemplates: any[] = [];
  viewGallery: boolean;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment;
  public maxDate: moment.Moment;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  selectedCat: any[] = [];
  selectedRelatedCat: any[] = [];
  metaList: any[] = [];
  RelatedCategories: any[] = [];

  categories: any[] = [];
  selectedTag: any[] = [];
  tags: any[] = [];
  allSelectedCat: any[] = [];
  allRelatedCategories: any[] = [];
  allSelectedTag: any[] = [];
  tempMeta: any = {};
  indexToEdit: number = null;

  modalRef: BsModalRef;
  config = {
    keyboard: true,
  };
  allSelectedRelated: any[] = [];
  isExternal: boolean = false;
  externalLink: any = "";
  newTabLink: boolean = false;
  user: any;
  redirecttopage: boolean = false;
  currentFolder: any = { folderPath: "" };
  themes: any[] = [];
  allClasses: any[] = [];
  colors: any[] = [];
  fonts: any[] = [];
  error: string;
  showDetail: boolean = false;
  tempId: number = 1;

  constructor(
    private modalService: BsModalService,
    private dialog: MatDialog,
     private snotifyService: ToastrService,
    private httpClient: HttpClient,
    private routing: Router,
    private route: ActivatedRoute,
    private moduleService: ModuleService,
    private authService: AuthService
  ) {
    
  }
 
  ngOnInit() {
    window.scrollTo(0, 0);
    this.post.id = this.route.snapshot.paramMap.get("id");
    // this.redirecttopage=this.redirecttopage||true
    if (this.post.id) {
      this.httpClient
        .get<any>("/BolgArchive/GetPostById/" + this.post.id)
        .subscribe((data: any) => {
          this.post.id = data.id;
          this.tempId = data.templateId || 1;
          this.GetAllTemplates();
          this.allSelectedCat = data.categoryList || [];
          this.getCat();
          this.allSelectedTag = data.tagList || [];
          this.getTag();
          this.RelatedCategories = data.relatedCategoriesSettings
            ? JSON.parse(data.relatedCategoriesSettings).RelatedCategories
            : [];

          this.post.postThumbnails = data.postThumbnails || [];
          this.post.Title = data.title;
          this.post.Description = data.description;
          this.post.Status = data.status == 2;
          this.post.htmlContent = data.postContent;
          this.post.shortDescription = data.shortDescription || " ";
          this.post.Slug = data.slug || "";
          this.post.orgSlug = data.orgSlug;
          this.post.Keywords = data.keywords;
          this.post.metaDescription = data.metaDescription;
          this.post.IsPrivate = data.IsPrivate;
          this.post.StatusDate = data.statusDate ? data.statusDate : null;
          this.post.ExpiryDate = data.expiryDate
            ? new Date(data.expiryDate)
            : null;
          var settings = data.settings ? JSON.parse(data.settings) : [];
          this.isExternal = settings.isExternal || false;
          // this.redirecttopage = settings.redirecttopage || false;
          this.externalLink = settings.link || "";
          this.newTabLink = settings.newTabLink || false;

          if (data.mediaURLs) {
            for (let i = 0; i < data.mediaURLs.length; i++) {
              const img = data.mediaURLs[i];
              this.post.postThumbnails.push({ id: img.id, publicUrl: img.url });
            }
          }

          if (this.post.ExpiryDate == null) this.post.expired = false;
          else this.post.expired = true;

          this.post.addtionalMetaTags = data.addtionalMetaTags
            ? JSON.parse(data.addtionalMetaTags)
            : [];
          if (this.post.addtionalMetaTags.length == 0) {
            this.post.addtionalMeta = false;
          } else this.post.addtionalMeta = true;
        });
    } else {
      this.post.StatusDate = new Date();
      this.getCat();
      this.getTag();
      this.GetAllTemplates();
      this.post.addtionalMetaTags = [];
      this.RelatedCategories = [];
      this.post.templateId = 1;
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  getCat() {
    this.httpClient
      .get("/Categories/GetCategoriesByTypeId/7")
      .subscribe((res: any) => {
        for (let i = 0; i < res.length; i++) {
          const element = res[i];
          this.categories.push({ id: element.id, label: element.name });
        }
        if (this.allSelectedCat.length > 0) {
          for (let i = 0; i < this.categories.length; i++) {
            const orgCat = this.categories[i];
            for (let j = 0; j < this.allSelectedCat.length; j++) {
              const selectCat = this.allSelectedCat[j];
              if (orgCat.label == selectCat.label) {
                this.selectedCat.push({ id: orgCat.id, label: orgCat.label });
              }
            }
          }
        }
      });
  }

  addCat(name) {
    return { id: 0, label: name };
  }

  getTag() {
    this.httpClient
      .get("/BolgArchive/GetAllPostsTags")
      .subscribe((res: any) => {
        this.tags = res;
        if (this.allSelectedTag.length > 0) {
          for (let i = 0; i < this.tags.length; i++) {
            const orgTag = this.tags[i];
            for (let j = 0; j < this.allSelectedTag.length; j++) {
              const selectTag = this.allSelectedTag[j];
              if (orgTag.label == selectTag.label) {
                this.selectedTag.push({ id: orgTag.id, label: orgTag.label });
              }
            }
          }
        }
      });
  }
  addTag(name) {
    return { id: 0, label: name };
  }
  runScript(e) {
    if (e.keyCode == 13) {
      var tb = document.getElementById("scriptBox");
      eval(tb.nodeValue);
      return false;
    }
  }
  prevent(event) {
    event.preventDefault();
  }
  AddMeta() {
    if (this.indexToEdit == null)
      this.post.addtionalMetaTags.push(this.tempMeta);
    else
      this.post.addtionalMetaTags[this.indexToEdit] = JSON.parse(
        JSON.stringify(this.tempMeta)
      );
    this.indexToEdit = null;
    this.tempMeta = {};
  }

  editMeta(m, i) {
    this.tempMeta = JSON.parse(JSON.stringify(m));
    this.indexToEdit = i;
  }

  GetAllTemplates() {
    this.allTemplates = [];
    this.httpClient
      .get("/PageTemplate/GetAllPageTemplates")
      .subscribe((res: any) => {
        for (let i = 0; i < res.length; i++) {
          const element = res[i];
          if (element.type == 3 && element.status == 1) {
            this.allTemplates.push(element);
          }
        }
        if (this.post.id && this.allTemplates.length > 0) {
          var template = this.allTemplates.find((x) => x.id == this.tempId);
          if (!template) {
            this.post.templateId = 1;
          } else {
            this.post.templateId = this.tempId;
          }
        }
      });
  }

  updateSlug() {
    const a =
      "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
    const b =
      "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");
    if (!this.post.Slug && this.post.Title) {
      this.post.Slug = this.post.Title.toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "").replace(/[^a-zA-Z0-9\u0600-\u06FF]/g, "-"); // Trim - from end of text;

      this.CheckSiteSlug(this.post.Slug);
    }
  }

  CheckSiteSlug(slug) {
    if (slug && slug != this.post.orgSlug) {
      this.post.slugError = "checking..";
      this.httpClient
        .get("/General/CheckSiteSlug/" + slug, { responseType: "text" })
        .subscribe((res: any) => {
          if (res != "ok") {
            this.post.slugError = res;
          } else this.post.slugError = "";
        });
    } else this.post.slugError = "";
  }

  close() {
    this.result.emit(0);
  }

  save(form, addAnother?) {
    if (form.invalid || this.selectedCat.length == 0) {
      Object.keys(form.controls).forEach((feild) => {
        form.controls[feild].markAsTouched(true);
      });
      this.error = "The form must be filled out";

      return;
    } else {
      let user = this.authService.getLoggedUser();
      const data = {
        Id: this.post.id || 0,
        CategoryList: this.selectedCat,
        TagList: this.selectedTag,
        CreatedById: user.id,
        TemplateId: +this.post.templateId,
        Slug: this.post.Slug,
        Title: this.post.Title,
        Description: this.post.Description,
        ShortDescription: this.post.shortDescription,
        ExpiryDate: this.post.expired ? this.post.ExpiryDate : null,
        Keywords: this.post.Keywords,
        metaDescription: this.post.metaDescription,
        addtionalMetaTags: this.post.addtionalMeta
          ? JSON.stringify(this.post.addtionalMetaTags)
          : null,
        IsPrivate: this.post.IsPrivate ? 2 : 1,
        Status: this.post.Status ? 2 : 1,
        StatusDate: this.post.StatusDate,
        StatusDesc: "Edited",
        SiteName: "no name",
        ThumbnailId: this.post.thumbnailId,
        PostContent: this.post.htmlContent,
        Media: [],
        RelatedCategoriesSettings: JSON.stringify({
          RelatedCategories: this.RelatedCategories,
        }),
        Settings: JSON.stringify({
          isExternal: this.isExternal,
          link: this.externalLink,
          newTabLink: this.newTabLink,
        }),
      };
      var abc = {
        id: this.post.id || 0,
        templateId: +this.post.templateId,
        categoryList: this.selectedCat,
        tagList: this.selectedTag,       
        title: this.post.Title,
        description: this.post.Description,
        shortDescription: this.post.shortDescription,
        expiryDate: this.post.expired ? this.post.ExpiryDate : null,
        keywords: this.post.Keywords,
        metaDescription: this.post.metaDescription,
        addtionalMetaTags: this.post.addtionalMeta
        ? JSON.stringify(this.post.addtionalMetaTags)
        : null,
        isPrivate: this.post.IsPrivate ? 2 : 1,
        postContent: this.post.htmlContent,
        slug: this.post.Slug,
        status: this.post.Status ? 2 : 1,
        statusDesc: "Edited",
        statusDate: this.post.StatusDate,
        siteId: 1,
        userId: user.id,
        siteName: "no name",
        media: [],
        relatedCategoriesSettings: JSON.stringify({
          RelatedCategories: this.RelatedCategories,
        }),
        settings: JSON.stringify({
          isExternal: this.isExternal,
          link: this.externalLink,
          newTabLink: this.newTabLink,
        }),
        
        
      };
      for (let i = 0; i < this.post.postThumbnails.length; i++) {
        const element = this.post.postThumbnails[i];
        abc.media.push(element.id);
      }

      this.post.templateId =
        this.post.templateId != 0 ? this.post.templateId : undefined;

      if (this.post.id) {
        this.httpClient
          .post(`/BolgArchive/EditPost`, data)
          .subscribe((res: any) => {
            if (res) {
              this.openNotifySuccess("Blog Saved");
              this.routing.navigate(["Blogs-Articles"]);
            }
          });
      } else {
        this.httpClient.post(`/BolgArchive/AddNewPost`, abc).subscribe(
          (res: any) => {
            if (res) {
              this.openNotifySuccess("Blog Saved");
              if (addAnother) {
                // this.reset()
                this.routing.navigate([`Blogs-Articles/edit/${res}`]);
              } else this.routing.navigate(["Blogs-Articles"]);
            }
          },
          (err) => {
            this.snotifyService.error(
              "",
              "No template selected please choose one",
              {
                timeOut: 2000,
                progressBar: true,
                tapToDismiss: true,
              }
            );
          }
        );
      }
    }
  }

  reset() {
    this.post.id = 0;
    this.selectedCat = [];
    this.selectedTag = [];
    this.post.templateId = 0;
    this.post.Slug = "";
    this.post.Title = "";
    this.post.Description = "";
    this.post.expired = null;
    this.post.Keywords = "";
    this.post.metaDescription = "";
    this.post.addtionalMeta = null;
    this.post.IsPrivate = 1;
    this.post.StatusDate = "";
    this.post.htmlContent = "";
    this.post.shortDescription = "";
    // $('.summernote').summernote('code', '');
    this.post.postThumbnails = [];
    this.post.status = 1;
    this.ngOnInit();
  }

  open(File) {
    const dialogRef = this.dialog.open(ViewFileComponent, { data: File });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === "add") {
      }
    });
  }

  removeMedia(File) {
    this.httpClient
      .delete("/Media/DeleteMedia/" + File.id)
      .subscribe((res: any) => {
        this.openNotifySuccess("File Deleted");
      });
  }

  openGallery(isMultiSelect) {
       const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { top: "0px", right: "0px" };
    dialogConfig.height = "100vh";
    dialogConfig.width = "50vw";
    dialogConfig.panelClass = "media-modal";
    // Accepted files [image,doc,pdf]
    dialogConfig.data = { isMultiSelect: isMultiSelect, files: ["image"] };

    let dialogRef = this.dialog.open(MediaDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
               if (isMultiSelect) {
          result.forEach((element) => {
            this.post.postThumbnails.push({
              id: element.id,
              url: element.publicUrl,
            });
          });
        } else {
          this.post.thumbnailId = result.id;
          this.post.thumbnailURL = result.publicUrl;
        }
      }
    });

    // var x = this.moduleService.ComponentFactory['GalleryComponent'];
    // if (this.moduleService.ComponentFactory['GalleryComponent']) {
    //   this.viewGallery = true
    //   this.content.clear();
    //   // create setting component
    //   const component: any = this.content.createComponent(x);
    //   // sending @Input() values
    //   component.instance.data = { enviroment: window['config'] };
    //   //  save @output()
    //   component.instance.imgUrl.subscribe(res => {
    //     if (res && res != null) {
    //       this.tempMenu.image = window['config'].apiUrl + '/' + res.publicUrl
    //       while (this.tempMenu.image.indexOf('\\') !== -1) {
    //         this.tempMenu.image = this.tempMenu.image.replace('\\', '/');
    //       }
    //       this.tempMenu.showMenuImage = true
    //     }
    //     this.viewGallery = false
    //     this.content.clear();
    //   });

    // }
  }

  getThumbnailUrl(url) {
    return window["config"].apiUrl + "/" + url;
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  postPublishHadler(event, post) {
    if (event.checked) {
      post.status = 4;
    } else {
      post.status = 2;
    }
  }

  openPostThumbnail(post, fileRef?) {
    console.log("post", post);
  }

  removePostThumbnail(image) {
    if (image) {
      var index = this.post.postThumbnails.findIndex((x) => x.id == image.id);
      this.post.postThumbnails.splice(index, 1);
    } else {
      this.post.thumbnailId = null;
      this.post.thumbnailURL = "";
    }
  }

  slugifyString(str) {
    var arabic = /[\u0600-\u06FF]/;
    if (str && arabic.test(str)) {
      return str
        .replace(/ /g, "-")
        .replace(/'(\w)/g, "")

        .replaceAll(",", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("؟", "")
        .replaceAll("+", "")
        .replaceAll("=", "")
        .replaceAll(",", "")
        .replaceAll("!", "")

        .replace(/,/g, ""); // Remove all comma
    } else {
      const a =
        "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
      const b =
        "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------";
      const regex =
        "/[دجحخ هعغفقثصضذطكمنتالبيسشظزوةىلارؤءئإلإلأأ؟آلآ]|.|s/_,:;";
      const e =
        "/ [دجحخ هعغفقثصضذطكمنتالبيسشظزوةىلارؤءئإلإلأأ؟آلآ] |.|s /------";
      const p = new RegExp(a.split("").join("|"), "g");
      const s = new RegExp(regex.split("").join("|"), "g");
      if (str) {
        return str
          .toString()
          .toLowerCase()
          .replace(/\s+/g, "-") // Replace spaces with -
          .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(s, (d) => e.charAt(regex.indexOf(d))) // Replace special characters
          .replace(/&/g, "-and-") // Replace & with 'and'
          .replace(/[^\w\-]+/g, "") // Remove all non-word characters
          .replace(/\-\-+/g, "-") // Replace multiple - with single -
          .replace(/^-+/, "") // Trim - from start of text
          .replace(/-+$/, "") // Trim - from end of text;
          .replace(/,/g, "") // Remove all comma
          .replace(/ /g, "-")
          .replace(/'(\w)/gi, ""); // Remove all apostrophe S
      }
    }
  }
}
